import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { subscribeNewsletter } from "@/lib/api";

export default function NewsletterForm({ testidPrefix = "newsletter" }) {
  const [email, setEmail] = useState("");
  const [org, setOrg] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Please enter your email");
    setLoading(true);
    try {
      await subscribeNewsletter({ email, organisation: org || undefined });
      toast.success("Subscribed. We'll be in touch.");
      setEmail("");
      setOrg("");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Could not subscribe. Try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={onSubmit}
      data-testid={`${testidPrefix}-form`}
      className="space-y-5"
    >
      <input
        type="text"
        placeholder="Organisation (optional)"
        value={org}
        onChange={(e) => setOrg(e.target.value)}
        className="editorial-input"
        data-testid={`${testidPrefix}-organisation`}
      />
      <div className="flex items-end gap-3">
        <input
          type="email"
          required
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="editorial-input"
          data-testid={`${testidPrefix}-email`}
        />
        <button
          type="submit"
          disabled={loading}
          data-testid={`${testidPrefix}-submit`}
          className="shrink-0 inline-flex items-center justify-center w-12 h-12 bg-[#C45A3C] hover:bg-[#9C6F2F] text-[#1F2A1B] transition-colors disabled:opacity-50"
          aria-label="Subscribe"
        >
          <ArrowRight size={18} />
        </button>
      </div>
      <p className="text-[#8A8775] text-xs leading-relaxed">
        Practical updates on environmental careers, training pathways and
        Indigenous workforce development. No spam.
      </p>
    </form>
  );
}
